import React from 'react'
import get from 'lodash/get'

const JobTag = props => {
  const { content, icon, show } = props

  if (!show) return null

  return (
    <div className="mr-4 my-2">
      <span
        className="px-0"
        style={{
          color: '#4a5f70',
          opacity: 1,
          fontSize: '16px',
        }}
      >
        {icon}
        {content}
      </span>
    </div>
  )
}

const JobTags = ({ location, detectedExtensions }) => {
  const postedAt = get(detectedExtensions, 'posted_at', null)
  const scheduleType = get(detectedExtensions, 'schedule_type', null)
  const workFromHome = get(detectedExtensions, 'work_from_home', null)

  return (
    <div className="d-flex mb-2 flex-wrap">
      <JobTag content={postedAt} icon={<i className="fal fa-clock mr-2" />} show={postedAt} />
      <JobTag content={location} icon={<i className="fal fa-map-marker mr-2" />} show={location} />
      <JobTag
        content={scheduleType}
        icon={<i className="fal fa-briefcase mr-2" />}
        show={scheduleType}
      />
      <JobTag
        content="Work from Home"
        icon={<i className="fal fa-home mr-2" />}
        show={workFromHome}
      />
    </div>
  )
}

export default JobTags



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobTags.js